import styled, { css } from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: 'white' | 'black' | string;
  setHeight?: number;
}

export const ComponentRefreshBtn = styled(Button)<IProps>`
  ${mixin.flex({ align: 'center', justify: 'center' })};
  column-gap: 6px;
  width: calc(100% - 40px);
  height: ${props => (props.setHeight ? `${props.setHeight}px` : '233px')};
  margin: 0 auto;
  background: #f9f9f9;

  .area-box {
    ${mixin.flex({ display: 'inline-flex' })}
    line-height: 130%;
    font-size: 14px;
    color: #000;
    font-weight: 500;

    .icon {
      ${mixin.flex({})};
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }

  ${props => {
    if (props.$bgType === 'black') {
      return css`
        background: #333;

        .area-box {
          border: 1px solid #e2e2e2;
          background: #fff;
          height: 40px;
          width: 155px;
        }
      `;
    }
    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    column-gap: ${mixin.pxToVw('6')};
    height: ${props =>
      props.setHeight
        ? mixin.pxToVw(String(props.setHeight))
        : mixin.pxToVw('233')};
  }

  @media ${({ theme }) => theme.media.pc} {
    column-gap: 10px;
    width: var(--pc-width);
    height: ${props => (props.setHeight ? `${props.setHeight}px` : '355px')};

    .area-box {
      font-size: 16px;

      svg {
        transform: scale(1);
      }
    }

    ${props => {
      if (props.$bgType === 'black') {
        return css`
          .area-box {
            color: #fff;
            border: 0;
            background: none;
            height: auto;
            width: auto;

            svg path {
              fill: #fff;
            }
          }
        `;
      }
      return null;
    }}
  }
`;
